import React from "react";
export const LogicContext = /*#__PURE__*/React.createContext(undefined);